import { Component, TemplateRef, ViewChild, signal } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';

import { HttpService } from 'src/app/services/http.service';
import { Site } from '../../bo/site';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { ModaleResultatComponent } from '../modale-resultat/modale-resultat.component';

@Component({
  selector: 'app-connexion',
  templateUrl: './connexion.component.html',
  styleUrls: ['./connexion.component.scss'],
  standalone: false
})

export class ConnexionComponent {
  username: string;
  password: string;
  usernameInvalide = false;
  passwordInvalide = false;
  identifiantsInvalides = false;
  compteBloque = false;
  erreurConnexion = false;
  nonAutorise = false;
  emailSupport = signal('');
  email: string;
  mdpOublieEmailInvalide = false;
  selectSite: Site;
  modalRef: BsModalRef;
  modalMdpOublie: BsModalRef;
  siteSelectionnables = signal<Site[]>([]);
  utilChoixSite = false;
  mdpOublieCompteBloque = false;
  mdpOublieErreur = false;

  @ViewChild('modalChoixSite') modalChoixSite: ModalDirective;

  constructor(private readonly http: HttpService, private readonly router: Router, private readonly traductionService: TraductionService, private readonly modalService: BsModalService,
    public utilService: UtilisateurService, private readonly fonctionsService: FonctionsService) {
    this.http.get<string>('Config/EmailAdministrateur').subscribe(resultat => {
      this.emailSupport.set(resultat);
    });
  }

  // async login() {
  //   if (this.validationFormulaire()) {
  //     this.fonctionsService.loading_screen(true);

  //     this.utilService.Login(this.username, this.password)
  //       .subscribe(async isLogged =>{
  //         console.log(isLogged);        
  //         this.fonctionsService.loading_screen(false);

  //         if(isLogged){
  //           this.OnLogin();
  //         }
  //         else{
  //           this.identifiantsInvalides = true;
  //         }
  //       },
  //        (error) => {
  //         this.fonctionsService.loading_screen(false);
  //         this.erreurConnexion = true;
          
  //       } );
  //     }
  // }


  
  // private OnLogin(){
  //   try {
  //     this.traductionService.changerLangue(this.utilService.utilisateur.langue.identifiantIso);            
  //   } catch (error) {
  //     console.error(error);
  //   }



  //   if (this.utilService.userRole == ExploreRole.ResponsableSite || this.utilService.userRole == ExploreRole.UtilisateurTerrain || this.utilService.userRole == ExploreRole.Client) {
  //     if (this.utilService.utilisateur.sites.length == 1) {
  //       this.utilService.setCurrentSite(this.utilService.utilisateur.sites[0]);
  //       this.router.navigate(['mysite', this.utilService.utilisateur.sites[0].siteId, 'myprojects'], { replaceUrl: true });
  //     }
  //      else {  //L'utilisateur terrain ou le client choisi sont site si plusieur lui sont affectés
  //       this.siteSelectionnables = this.utilService.utilisateur.sites.filter(s => s.isActif == true);
  //       this.utilChoixSite = true;
  //       this.modalChoixSite.config = { backdrop: true, ignoreBackdropClick: true, keyboard: false };
  //       this.modalChoixSite.show();
  //     }
  //   } else {
  //     this.router.navigate([''], { replaceUrl: true });
  //   }
  //       // } else {
  //       //   this.fonctionsService.loading_screen(false);
  //       //   //Gestion erreur login isLockedOut, isNotAllowed
  //       //   if (result["isLockedOut"]) {
  //       //     this.compteBloque = true;
  //       //   } else if (result["isNotAllowed"]) {
  //       //     this.nonAutorise = true;
  //       //   } else {
  //       //     this.identifiantsInvalides = true;
  //       //   }
  //       // }
  // }

  
  validationFormulaire() {
    this.usernameInvalide = false;
    this.passwordInvalide = false;
    this.identifiantsInvalides = false;
    this.compteBloque = false;
    this.nonAutorise = false;

    if (this.username === null || this.username === undefined || this.username.trim() == '') {
      this.usernameInvalide = true;
    }
    if (this.password === null || this.password === undefined || this.password.trim() == '') {
      this.passwordInvalide = true;
    }
    return (!this.usernameInvalide && !this.passwordInvalide);
  }

  ouvrirFenetreMdpOublie(templateResetMdp: TemplateRef<any>) {
    if (!(this.username === null || this.username === undefined || this.username.trim() === ''))
      this.email = this.username;
    this.modalMdpOublie = this.modalService.show(templateResetMdp, { class: 'modal-sm', ignoreBackdropClick: true });
  }

  demandeNouveauMdp() {
    this.mdpOublieEmailInvalide = false;
    this.mdpOublieCompteBloque = false;
    if (this.email === null || this.email === undefined || this.email.trim().length == 0)
      this.mdpOublieEmailInvalide = true;
    else {
      this.fonctionsService.loading_screen(true);
      this.http.post('Authentication/AskResetPassword', { Username: this.email }).subscribe(resultat => {
        this.fonctionsService.loading_screen(false);
        if (resultat['succeeded']) {
          this.traductionService.translate.get(['CONNEXION.MDP_OUBLIE_MESSAGE_TITRE_ENVOYE', 'CONNEXION.MDP_OUBLIE_MESSAGE_ENVOYE']).subscribe(traduction => {
            const initialState = {
              titre: traduction['REFERENTIEL_UTILISATEUR.MODALE_TITRE_REUSSIE'],
              resultat: traduction['CONNEXION.MDP_OUBLIE_MESSAGE_ENVOYE']
            };
            this.modalRef = this.modalService.show(ModaleResultatComponent, { initialState });
          });
          this.modalMdpOublie.hide();
          this.email = '';
        } else if (resultat['errors'][0]['description'] == 'Locked')
          this.mdpOublieCompteBloque = true;
        else
          this.mdpOublieErreur = true;
      }, () => this.fonctionsService.loading_screen(false));
    }
  }

  annulerDemandeMdp() {
    this.email = '';
    this.modalMdpOublie.hide();
  }

  selectionSite() {

    if(this.selectSite.siteId == undefined) return;

    this.utilService.setCurrentSite(this.selectSite);
    this.router.navigate(['mysite', this.selectSite.siteId], { replaceUrl: true });
    this.modalChoixSite.hide();
  }
}
